// extracted by mini-css-extract-plugin
module.exports = {"partnersLayout":"_6J-S8"};